// extracted by mini-css-extract-plugin
export default {"container":"qqfHdcQItVsbDjg1Yi7G","active":"z6w3llLTjRjiu9nEndJC","header":"wepRUo4LZvQ6zacoBZ6t","description":"nL3MdrJ5H0MVdTyA7KgY","icon":"FeX0cFBtP71nZzxqxY3r"};